import { NgModule } from '@angular/core';
import { MuiCardActions } from './mui-card-actions.component';
import { MuiCardContent } from './mui-card-content.component';
import { MuiCardHeader } from './mui-card-header.component';
import { MuiCard } from './mui-card.component';


@NgModule({
  declarations: [
    MuiCard,
    MuiCardHeader,
    MuiCardActions,
    MuiCardContent
  ],
  exports: [
    MuiCard,
    MuiCardHeader,
    MuiCardActions,
    MuiCardContent
  ]
})
export class MuiCardModule {

}
